import { SortDirection } from "../../components/Table/types";
import { TicketStatus } from "../../constants/ticketStatus";

export enum ColumnSort {
    TICKET = 'numeroticket',
    DATE = 'datainclusao',
    STATUS = 'status',
    SOLICITANTE = 'solicitante',
    PRIORIDADE_CLIENTE = 'prioridadecliente',
    CANAL_DIRETO = 'canalDireto',
}

export type TicketRequest = {
    numeroTicket?: number;
    situacao?: string;
    situacaoEspecifica?: string;
    oidCliente?: number;
    isMaster: boolean;
    pagina?: number;
    tamanhoPagina?: number;
    campoOrdenado?: ColumnSort
    sentidoOrdenacao?: SortDirection
    dataInicial?: string
    dataFinal?: string
    solicitante?: number
    titulo?: string
}

export type Ticket = {
    ticket: number;
    inclusao: string;
    titulo: string;
    descricaoCurta: string;
    tipo: string;
    solicitante?: string;
    status: TicketStatus;
    diagnostico: string,
    versao: string,
    actions?: string
    referenciaExterna?: string
    retornoCliente: boolean
    responsavel: string
    criadoPor: string
    canalDiretoAplicado: boolean
    canalDiretoRespondido: boolean
    prioridadeCliente: number
    numeroTopicoPreAtendimento: number
    possuiAnexo: boolean
}

export type TicketResponse = {
    tickets: Ticket[];
    paginaAtual: number;
    totalPaginas: number;
    tamanhoPagina: number;
    totalItens: number;
}

export type PriorityTicketResponse = {
    prioridadeCliente?: number
    ticket: number
    inclusao: string
    titulo: string
    tipo: string
    solicitante: string
}


export type AttachmentTicketsResponse = {
    anexoTickets?: AttachmentTickets[]
}

export type AttachmentTickets = {
    nomeArquivo: string
    data: string
}


export type TicketHistorico = {
    data: string;
    criadoPor: string;
    descricao: string;
    oidCriadoPor: string;
}

export type TicketHistoricoResponse = {
    historicos: TicketHistorico[];
}


export type AddTicketPriorityRequest = {
    oidCliente: number;
    prioridades: PriorityUpdateRequest[];
}


export type PriorityUpdateRequest = {
    ordem: number
    ticket: number
}

export type TicketReferenciaExterna = {
    ticket: number
    tipo: string
    responsavel: string
    criadoPor: string
    versao: string
    inclusao: string
}